import { feetPerMeter } from "./constants";

export const mapboxToken =
  "pk.eyJ1IjoiZ3JhaGFtZ2liYm9ucyIsImEiOiJja3Qxb3Q5bXQwMHB2MnBwZzVyNzgyMnZ6In0.4qLjlbLm6ASuJ5v5gN6FHQ"; // TODO: Change

export const imageryUrl = `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.jpg80?access_token=${mapboxToken}`;
export const elevationUrl = `https://api.mapbox.com/v4/mapbox.terrain-rgb/{z}/{x}/{y}.pngraw?access_token=${mapboxToken}`;

export const defaultAltitude = 3048;
export const defaultGlideSlope = 6.5;
export const defaultSpeed = 68;
export const minimumWeight = 1470;
export const maximumWeight = 2000;
export const turnDistance = 5280 / feetPerMeter;
export const baseDistance = 1390;
